export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-13.jpg'),
        title: '企業アプリケーション',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '​​あらゆる組織の重要な構成要素',
      description: `<p style="font-size:1.05rem">組織が成長するにつれて、市販のソフトウェアだけでは企業環境の要件を満たせなくなることがよくあります。企業や大規模組織は独自の業務プロセス、データ構造、ワークフローを持っており、企業向けアプリケーションはまさにそのために存在します。これは特定の組織ニーズに合わせて設計された大規模なソフトウェアプラットフォームです。企業向けアプリケーション（EASとも呼ばれる）は、企業、教育機関、銀行、政府機関などあらゆる組織にとって重要な要素です。企業アプリケーションは組織のワークフローと生産性を向上させます。MaesInfoのソフトウェア開発サービスは、組織のニーズに合わせたカスタム企業アプリケーションの開発を含みます。弊社の開発チームは世界中のお客様向けにソフトウェアを構築した豊富な経験を有しています。私たちが開発する企業アプリケーションには、例えば以下のようなものが含まれます（これらに限定されません）：</p>
      <p>決済処理システム、
    自動請求システム、
    CRM（顧客関係管理）、
    ERP（企業資源計画）http://maesinfo.com/solutions/erp.html、
    BCP（事業継続計画）、
    RFID（無線周波数識別）http://maesinfo.com/solutions/rfid.html、
    ITサービス管理など</p>`
    },
    {
      title: '​​MaesInfoと協力する利点：',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-13.jpg')+`)"></span>
      <span class="list">
      <i></i>弊社のコンサルタントチームは、適切なアプリケーション技術とサービスプロバイダーの選定についてアドバイスします。急速に変化するグローバル市場でどのように事業を発展させるかをご支援します。<br/>
     <i></i>企業アプリケーションをクラウドへ移行する支援を行います。多くの企業がオンデマンド型サービスへ移行しています。<br/>
     <i></i>弊社はスケーラブルな企業向けアプリケーションを構築できるため、複雑な要求にも対応可能です。<br/>
     <i></i>MaesInfoは会計、販売、人事、製造など、組織内の業務プロセスを単一のソフトウェアアーキテクチャで統合します。<br/>
     <i></i>ベンダー、顧客、パートナーを企業アプリケーションに統合できます。<br/>
     <i></i>コスト効果の高いソリューションだけでなく、時間の節約につながるソリューションを提供します。<br/>
     <i></i>インターネット、イントラネット、企業ネットワークなど、さまざまなネットワーク環境に展開し、適切なセキュリティ対策を講じます。
      </span>`
    }
  ]
}
